import {onInput} from '@github-ui/onfocus'
import {fire} from 'delegated-events'

function parameterizeName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '') // trim invalid characters
    .replace(/\s/g, '-') // convert spaces to hyphens
}

// Function to handle auto update for the slug field (known as subdomain in Proxima)
function updateAutoField(nameInput: HTMLInputElement, selector: string) {
  const targetInput = document.querySelector(`${selector}[data-auto-update="true"]`)
  if (!(targetInput instanceof HTMLInputElement)) return false

  targetInput.value = parameterizeName(nameInput.value)
  fire(targetInput, 'input') // remove once auto-check-element is updated to only validate on blur (currently behind feature flag)
  fire(targetInput, 'blur') // Manually trigger blur event to trigger auto-check-element, which now only runs on blur
  return true
}

// auto update the slug/subdomain input if needed
onInput('.js-business-name', function (event) {
  const nameInput = event.target as HTMLInputElement

  updateAutoField(nameInput, '.js-business-slug')
  updateAutoField(nameInput, '.js-business-subdomain')
})

onInput('.js-business-slug', function (event) {
  const slugInput = event.target as HTMLInputElement
  const slugValue = slugInput.value
  const hasEmptySlugValue = slugValue.trim() === ''
  slugInput.setAttribute('data-auto-update', `${hasEmptySlugValue}`)
  // sync icon is only used in stafftools
  const icon = document.querySelector<HTMLElement>('.js-name-slug-sync-icon')
  if (icon) {
    if (hasEmptySlugValue) {
      icon.removeAttribute('hidden')
    } else {
      icon.setAttribute('hidden', 'hidden')
    }
  }
})

onInput('.js-business-subdomain', function (event) {
  const subdomainInput = event.target as HTMLInputElement
  const hasEmptySlugValue = subdomainInput.value.trim() === ''
  subdomainInput.setAttribute('data-auto-update', `${hasEmptySlugValue}`)
})
